import axios from "axios";
import {Notify} from 'vant';
import {API_DOMAIN, TOKEN_KEY} from "../config/constant"
import weChatUtil from "./weChatUtil";

//axios.defaults.baseURL = process.env.NODE_ENV === "production" ?  API_DOMAIN : 'http://localhost:8082';
axios.defaults.baseURL = API_DOMAIN ;

axios.interceptors.request.use(config => {
    if(config.url.indexOf("restapi.amap.com") > 0) {
      return config;
    }
    if(config.url === '/login'){
      localStorage.removeItem(TOKEN_KEY);
      return config;
    }
    const token =  localStorage.getItem(TOKEN_KEY);
    if (token != null) {
      config.headers.Authorization = `${token}`;
    }

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(function (response){
  // 处理响应数据
  return response.data;
}, function (error){
  if (error.response) {
    switch (error.response.status) {

      case 401:
      case 403:
        //跳转到登录界面
        Notify("登录过期");
        localStorage.removeItem(TOKEN_KEY);
        window.location.href = weChatUtil.redirectAuth();
    }
  }
  //处理响应失败
  return Promise.reject(error);
});


export default {
  get(url, params) {
    return axios.get(url, params).then(res => (res)).catch(err => (err))
  },
  post(url, params, config){
    return axios.post(url, params, config).then(res => (res)).catch(err => (err))
  },
  delete(url, params){
    return axios.delete(url, params).then(res => (res)).catch(err => ({err}))
  },
  put(url, params, config){
    return axios.put(url, params, config).then(res => (res)).catch(err => ({err}))
  }

};
